import { usePresence } from "framer-motion";
import { ComponentProps, useEffect } from "react";
import { AnimatedLayoutNodeSlot } from "./lib/EndlessNode/styles";

const NODE_ANIMATION_DURATION_MS = 500;

type StableAnimatedNodeSlotProps = ComponentProps<
	typeof AnimatedLayoutNodeSlot
> & {
	exitWidth: string;
	exitHeight: string;
};

const StableAnimatedNodeSlot = ({
	children,
	exitWidth,
	exitHeight,
	...props
}: StableAnimatedNodeSlotProps) => {
	const [isPresent, safeToRemove] = usePresence();

	useEffect(() => {
		if (isPresent || !safeToRemove) {
			return;
		}

		const timeoutId = window.setTimeout(
			safeToRemove,
			NODE_ANIMATION_DURATION_MS
		);
		return () => window.clearTimeout(timeoutId);
	}, [isPresent, safeToRemove]);

	return (
		<AnimatedLayoutNodeSlot
			{...props}
			layout={isPresent ? "position" : false}
			transformTemplate={isPresent ? undefined : () => "none"}
			style={
				isPresent
					? { ...props.style, zIndex: 1 }
					: {
							...props.style,
							position: "absolute",
							top: 0,
							left: 0,
							gridColumn: "auto",
							gridRow: "auto",
							width: exitWidth,
							height: exitHeight,
							zIndex: 0
					  }
			}
		>
			{children}
		</AnimatedLayoutNodeSlot>
	);
};

export const PortraitAnimatedNodeSlot = (
	props: ComponentProps<typeof AnimatedLayoutNodeSlot>
) => (
	<StableAnimatedNodeSlot
		{...props}
		exitWidth="100%"
		exitHeight="calc((100% - 2.4em) / 4)"
	/>
);

export const PortraitSixAnimatedNodeSlot = (
	props: ComponentProps<typeof AnimatedLayoutNodeSlot>
) => (
	<StableAnimatedNodeSlot
		{...props}
		exitWidth="calc((100% - 0.5em) / 2)"
		exitHeight="calc((100% - 1em) / 3)"
	/>
);

export const LandscapeAnimatedNodeSlot = ({
	columns,
	...props
}: ComponentProps<typeof AnimatedLayoutNodeSlot> & { columns: number }) => (
	<StableAnimatedNodeSlot
		{...props}
		exitWidth={`calc(100% / ${columns})`}
		exitHeight="100%"
	/>
);
